import { useEffect, useMemo } from 'react';
import { mapValues } from 'lodash';

import { useFormState } from '../../../../../hocs/useFormWithValidation';
import { initialStateFields, validateRequiredFields } from './fields';
import { VISIT_DOCUMENTS_TYPES } from './constants';

export function useUploadDocumentForm(attachment, allowedCategory) {
  const { formState, handleFormChange, clearForm } = useFormState(
    initialStateFields,
  );
  const stateCategory = formState[VISIT_DOCUMENTS_TYPES.CATEGORY];
  const stateSubcategory = formState[VISIT_DOCUMENTS_TYPES.SUB_CATEGORY];

  function handleRestrictionSelectField(fieldKey) {
    if (formState) {
      const populate = mapValues(formState, (value, key) => {
        if (key === fieldKey) return null;

        return formState[key] || null;
      });
      handleFormChange(populate);
    }
  }

  useEffect(() => {
    handleRestrictionSelectField(VISIT_DOCUMENTS_TYPES.SUB_CATEGORY);
  }, [stateCategory]);

  const isValid = validateRequiredFields({
    ...formState,
    documents: attachment ? attachment.file : null,
  });

  const handleChooseCategorySubCategory = () => {
    const { category: currentCategoryId } = formState;
    const allCategories = allowedCategory.map(({ id, name }) => {
      return { label: name, value: id };
    });
    const currentCategory = allowedCategory.filter(
      ({ id }) => id === currentCategoryId,
    );

    const currentSubcategories =
      currentCategory.length > 0
        ? currentCategory[0].documentSubcategories.map(({ id, name }) => ({
            label: name,
            value: id,
          }))
        : [];

    return {
      categoryOptions: allCategories,
      subcategoryOptions: currentSubcategories,
    };
  };

  const {
    categoryOptions,
    subcategoryOptions,
  } = handleChooseCategorySubCategory();

  return useMemo(
    () => ({
      formState,
      handleFormChange,
      clearForm,
      isValid,
      categoryOptions,
      subcategoryOptions,
      stateCategory,
      stateSubcategory,
    }),
    [
      formState,
      isValid,
      categoryOptions,
      subcategoryOptions,
      stateCategory,
      stateSubcategory,
    ],
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/AddDocumentForm/useUploadDocumentForm.js